
// export const getHierarchy = (data, selectedHierarchyName) => {
//   console.log(selectedHierarchyName, "selectedHierarchyName")
//   if (!data) return [];

//   const result = [];

//   // Add current selected item with correct label
//   result.push({
//     label: selectedHierarchyName,
//     value: data.name,
//   });
//   if (data.state) {
//     result.unshift({ label: "State", value: data.state.name });
//   }

//   if (data.department) {
//     result.unshift({ label: "Department", value: data.department.name });
//     result.unshift({ label: "State", value: data.department.state?.name });
//   }

//   if (data.circle) {
//     result.unshift({ label: "Circle", value: data.circle.name });
//     result.unshift({
//       label: "Department",
//       value: data.circle.department?.name,
//     });
//     result.unshift({
//       label: "State",
//       value: data.circle.department?.state?.name,
//     });
//   }

//   if (data.division) {
//     result.unshift({ label: "Division", value: data.division.name });
//     result.unshift({ label: "Circle", value: data.division.circle?.name });
//     result.unshift({
//       label: "Department",
//       value: data.division.circle?.department?.name,
//     });
//     result.unshift({
//       label: "State",
//       value: data.division.circle?.department?.state?.name,
//     });
//   }

//   return result;
// };



export const getHierarchy = (data, selectedHierarchyName) => {
  if (!data) return [];

  const result = [];

  // Add current selected item with correct label
  result.push({
    label: selectedHierarchyName,
    value: data.name,
  });

  switch (selectedHierarchyName) {
    case "Department":
      if (data.state) {
        result.unshift({ label: "State", value: data.state.name });
      }
      break;
    case "Circle":
      if (data.department) {
        result.unshift({ label: "Department", value: data.department.name });
        result.unshift({ label: "State", value: data.department.state?.name });
      }
      break;
    case "Division":
      if (data.circle) {
        result.unshift({ label: "Circle", value: data.circle.name });
        result.unshift({
          label: "Department",
          value: data.circle.department?.name,
        });
        result.unshift({
          label: "State",
          value: data.circle.department?.state?.name,
        });
      }
      break;
    case "Sub-Division":
      if (data.division) {
        result.unshift({ label: "Division", value: data.division.name });
        result.unshift({ label: "Circle", value: data.division.circle?.name });
        result.unshift({
          label: "Department",
          value: data.division.circle?.department?.name,
        });
        result.unshift({
          label: "State",
          value: data.division.circle?.department?.state?.name,
        });
      }
      break;

    default: break;

  }

  return result;
};
